import { sva } from "@agapi/ui/panda/css";

export const checklistItemStyles = sva({
  slots: ['root', 'label'],
  base: {
    root: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: { base: "1", lg: "2" },
    },
    label: {
      fontSize: "xs",
      fontWeight: "medium",
      lineHeight: "none"
    }
  }
});
